import 'bootstrap/dist/css/bootstrap.min.css';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './views/Navbar';
import Navbar2 from './views/Navbar2';
import HomePage from "./views/HomePage";
import Footer from "./components/Footer"
import { SearchProvider } from "./context/SearchContext";
import LoginPage from "./views/LoginPage";
import RegisterPage from "./views/Register";
import MinhaContaPage from "./views/MinhaContaPage";
import ProductPage from "./views/ProductPage";
import Contact from "./views/Contact";
import { CategoryProvider } from './context/CategoryContext';
import CartPage from "./views/CartPage";
import CheckoutPage from "./views/CheckoutPage";
import DeliveryPage from "./views/DeliveryPage"
import MetodoPagamentoPage from "./views/MetodoPagamentoPage"
import Encomenda from "./views/PaginaEncomenda"
import Politicas from "./views/TermsAndConditions"
import ResumoPedidoPage from "./views/ResumoPedidoPage"
import ScrollToTop from "./views/ScrollToTop"
import Address from "./views/AddressForm";
import CadastroFatura from './views/CadastroFatura';
import { AuthProvider } from "./context/authContext";
import { CartProvider } from "./context/CartContext";
import "./App.css";
import { ProductFilterProvider } from './context/ProductFilterContext';
import CategoryPage from './views/CategoryPage';
import { useState } from "react";
import ConfirmarEncomenda from "./views/ConfirmarEncomenda";
import Robo from "./views/Robo"
import Destaques from './views/Destaques';

function App() {
  return (
    <Router>
       
      <AuthProvider>
      <ScrollToTop/>
        <CartProvider>
        <SearchProvider>
        
        <Navbar />
          
          <ProductFilterProvider>
          <Navbar2/>
          <CategoryProvider>
          <Robo />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/B" element={<CadastroFatura />} />
            <Route path="/minha-conta" element={<MinhaContaPage />} />
            <Route path="/loginpage" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/Address" element={<Address />} />
            <Route path="/pagamento" element={<MetodoPagamentoPage />} />
            <Route path="/pagina-encomenda" element={<Encomenda />} />
            <Route path="/resumo-final" element={<ResumoPedidoPage />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/product/:id" element={<ProductPage />} />
            
            <Route path="/confirmar-encomenda" element={<ConfirmarEncomenda />} />
            <Route path="/politicas" element={<Politicas />} />
            <Route path="/entrega" element={<DeliveryPage />} />
            <Route path="/category/:categoryName" element={<CategoryPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            
          </Routes>
          </CategoryProvider>
          </ProductFilterProvider>
          </SearchProvider>
        </CartProvider>
        <Footer/>
      </AuthProvider>
      
    </Router>
  );
}

export default App;
